var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalisis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 4.6875C10.7143 3.13477 12.154 1.875 13.9286 1.875H16.0714C17.846 1.875 19.2857 3.13477 19.2857 4.6875V25.3125C19.2857 26.8652 17.846 28.125 16.0714 28.125H13.9286C12.154 28.125 10.7143 26.8652 10.7143 25.3125V4.6875ZM0 15.9375C0 14.3848 1.43973 13.125 3.21429 13.125H5.35714C7.1317 13.125 8.57143 14.3848 8.57143 15.9375V25.3125C8.57143 26.8652 7.1317 28.125 5.35714 28.125H3.21429C1.43973 28.125 0 26.8652 0 25.3125V15.9375ZM24.6429 5.625H26.7857C28.5603 5.625 30 6.88477 30 8.4375V25.3125C30 26.8652 28.5603 28.125 26.7857 28.125H24.6429C22.8683 28.125 21.4286 26.8652 21.4286 25.3125V8.4375C21.4286 6.88477 22.8683 5.625 24.6429 5.625Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisis);
export default __webpack_public_path__ + "static/media/Analisis.fef3dded7a9b8842c420203cb17a4f08.svg";
export { ForwardRef as ReactComponent };